import { useState } from "react";
import Api from "../functions/Api";
import { ValidationResponse } from "../functions/validation";

const useBlocks = ({ handleMuestraSnack, handleInput, getLots }) => {
  const resultEmpty = [
    {
      ID_MANZANA: 0,
      CODIGO: "El desarrollo seleccionado no tiene manzanas asignadas"
    }
  ];
  const [ejecutaapi] = Api();
  const [blocks, setblocks] = useState([]);
  const [idBlock, setIdBlock] = useState(0);

  const onChangeBlock = value => {
    setIdBlock(value);
  };

  const getBlocks = development => {
    let usuario = localStorage.getItem("user");
    setblocks([]);
    handleInput && handleInput(0);
    getLots && getLots(-1);
    const body = JSON.stringify({
      pIdDesarrollo: development && development.ID_DESARROLLO,
      usuario: JSON.parse(usuario).email
    });

    ejecutaapi("obtienemanzanaxdesarrollo", body).then(data => {
      let { result, error } = ValidationResponse(data);

      if (error !== "") handleMuestraSnack(error, "error");
      if (result !== null) setblocks(result.length > 0 ? result : resultEmpty);
    });
  };

  const deleteBlock = (idManzana, developmentObj) => {
    let usuario = localStorage.getItem("user");
    const body = JSON.stringify({
      pIdManzana: idManzana,
      usuario: JSON.parse(usuario).email
    });
    ejecutaapi("eliminamanzana", body).then(data => {
      if (data && data.Ok) {
        const rows = data.result[0];
        const r = Array.isArray(rows) ? rows[0] : rows;
        if (r && r.sResultado === 1) {
          handleMuestraSnack(r.sMensaje, "success");
          setIdBlock(0);
          getBlocks(developmentObj);
        } else if (r && r.sMensaje) {
          handleMuestraSnack(r.sMensaje, "warning");
        }
      } else {
        handleMuestraSnack("Error al eliminar manzana", "error");
      }
    });
  };

  return {
    blocks,
    getBlocks,
    onChangeBlock,
    idBlock,
    deleteBlock
  };
};

export default useBlocks;
